export class BillingSyncConfigRequest {
  constructor(private billingSyncKey: string) {}
}
